module.exports = function isNonNullObject(value) {
  return require("@is-(unknown)/is-non-null-object")(value)
}